import React from 'react'
import ClassNames from 'classnames'
import { ButtonStyle } from './styled'

/**
 * Button description
 * - ...
 */

export class Button extends React.PureComponent {
  render() {
    const {
      className,
      children,
      title,
      id,
      onClick,
      onMouseEnter,
      onMouseLeave,
      disabled,
      isDisable,
      style,
    } = this.props

    return (
      <ButtonStyle
        className={ClassNames(
          'button',
          { 'is-disabled': disabled || isDisable },
          className
        )}
        id={id}
        style={style}
        title={title}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        disabled={disabled || isDisable}
      >
        {children}
      </ButtonStyle>
    )
  }
}
